/*jshint esversion: 9 */
/*jshint sub:true*/
// import { mapGetters, mapActions } from 'vuex';
import { mapGetters, mapActions, mapState } from 'vuex';

import Wallet from '@/components/ProjectWallet/Wallet.component.vue';
import WalletSettings from '@/components/ProjectWallet/WalletSettings.component.vue';
import WalletTakt from '@/components/ProjectWallet/WalletTakt.component.vue';
import WalletTaktHeader from '@/components/ProjectWallet/WalletTaktHeader.component.vue';
import WalletTaktBody from '@/components/ProjectWallet/WalletTaktBody.component.vue';
import WalletTrain from '@/components/ProjectWallet/WalletTrain.component.vue';
import WalletWorkPackage from '@/components/ProjectWallet/WalletWorkPackage.component.vue';
import WalletWorkPackageRework from '@/components/ProjectWallet/WalletWorkPackageRework.component.vue';
import WalletWorkPackageHeader from '@/components/ProjectWallet/WalletWorkPackageHeader.component.vue';
import WalletWorkPackageBody from '@/components/ProjectWallet/WalletWorkPackageBody.component.vue';
import WalletWorkPackageCutOut from '@/components/ProjectWallet/WalletWorkPackageCutOut.component.vue';
import WalletWorkPackageStatus from '@/components/ProjectWallet/WalletWorkPackageStatus.component.vue';

import WaggonInfoStatus from '@/components/ProjectTaktPlan/WaggonInfoStatus.component.vue';
import WaggonInfoNavButton from '@/components/ProjectTaktPlan/WaggonInfoNavButton.component.vue';
import WaggonInfoBody from '@/components/ProjectTaktPlan/WaggonInfoBody.component.vue';


import StandardOverflowButton from '@/components/StandardComponents/StandardOverflowButton.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue';

import TIcon from '@/components/Taktify/TIcon.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIconButton from '@/components/Taktify/TIconButton.component.vue';

import SubStep from '@/components/MicroLevel/SubStep.component.vue';

import { getFileTypeFromExtenion } from '@/helpers/util.js';
// import { json } from 'mathjs';

export const WalletMixin = {
  components: {
    Wallet,
    WalletSettings,
    WalletTakt,
    WalletTaktHeader,
    WalletTaktBody,
    WalletTrain,
    WalletWorkPackage,
    WalletWorkPackageRework,
    WalletWorkPackageHeader,
    WalletWorkPackageBody,
    WalletWorkPackageCutOut,
    WalletWorkPackageStatus,

    WaggonInfoStatus,
    WaggonInfoNavButton,
    WaggonInfoBody,

    StandardOverflowButton,
    StandardFlexBox,
    StandardDataField,
    StandardDialogFullScreen,

    TIcon,
    TText,
    TIconButton,

    SubStep,
  },
  data: () => ({
    show_calendar_weeks: false,
    nav_direction: 'right',
    update_key_add_comment: 0,
    update_key_add_image: 0,
    new_image: {
      file: false,
      local_url: false,
      name: false,
      comment: '',
      extension: '',
      type: 'other'
    },
    new_step_image: {
      file: false,
      local_url: false,
      name: false,
      comment: '',
      step_id: false,
      extension: '',
      type: 'other',
      step_type: 'other'
    },
    first_touch: {},
    mobile_show_settings: false,
    selected_twork_package_id: -1,
    show_interaction_slots: false,
    selected_substep: {id: -1},
    moving_substep: false,
    is_mouse_down: false,
    is_mouse_moved: false,
    substep_cache: {show: false, id: -1, day_index: -1},
    substep_move: 'body',
    initial_slot: false,
    initial_start_offset: 0,
    initial_end_offset: 0,
  }),
  computed: {
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObject',
      'getUObjectParent'
    ]),
    ...mapGetters('Project', [
      'getOwnTWorkPackages',
      'getProject',
      'hasProjectPermission',
      'getStatusArray',
      'getStatisticsTrainSelector',
      'getFullStatusArray',
      'getProjectTaktareas'
    ]),
    ...mapGetters('ProjectWallet', [
      'getUpdateKeyStepCard',
      'getWalletSettings',
      'getStepCards',
      'getWorkCard',
      'getQualityCard',
      'getDefectCard',
      'getHandoverCard',
      'getLogisticCard',
      'getDesignCard',
    ]),
    ...mapGetters('ProjectCalendar', [
      'getCalendar',
      'getCurrentTaktIndex',
      'isShowCalendarWeeks',
    ]),
    ...mapGetters('Train', [
      'getTrain',
      'getWorkpackagesInTakt'
    ]),
    ...mapGetters('TWorkPackage', [
      'getTWorkpackageColors',
      'getTWorkpackageIcons'
    ]),
    ...mapGetters('View', [
      'isShowOwnWps',
      'isMobileWalletShowSettings',
      'getWalletWorkpackageHeaderItems',
      'isWalletShowWorkpackages',
      'getUseOnSite',
    ]),
    ...mapGetters('WorkPackage', [
      'getNewIcon'
      ],
    ),
    ...mapState('View', [
      'isMicroView',
      'microlevel_taktarea_filter',
      'new_substep_step_id',
      'new_substep_step_type',
      'new_substep_search_step_id',
    ]),
    getWaggonInfoNavigation: function() {
      switch (this.$route.matched[4].name) {
        case 'ProjectWalletWorkPackageInfo':
          return {
            up: false,
            right: 'ProjectWalletWorkPackageLogList',
            down: 'ProjectWalletWorkPackageWorkSteps',
            left: 'ProjectWalletWorkPackageCosts',
          };
        case 'ProjectWalletWorkPackageWorkSteps':
          return {
            up: 'ProjectWalletWorkPackageInfo',
            right: 'ProjectWalletWorkPackageImages',
            down: 'ProjectWalletWorkPackageQualitySteps',
            left: false,
          };
        case 'ProjectWalletWorkPackageQualitySteps':
          return {
            up: 'ProjectWalletWorkPackageWorkSteps',
            right: 'ProjectWalletWorkPackageMessageBoard',
            down: 'ProjectWalletWorkPackageDefectSteps',
            left: false,
          };
          case 'ProjectWalletWorkPackageDefectSteps':
            return {
              up: 'ProjectWalletWorkPackageQualitySteps',
              right: 'ProjectWalletWorkPackageMessageBoard',
              down: 'ProjectWalletWorkPackageHandoverSteps',
              left: false,
            };
          case 'ProjectWalletWorkPackageHandoverSteps':
            return {
              up: 'ProjectWalletWorkPackageDefectSteps',
              right: 'ProjectWalletWorkPackageMessageBoard',
              down: 'ProjectWalletWorkPackageDesignSteps',
              left: false,
            };
          case 'ProjectWalletWorkPackageDesignSteps':
            return {
              up: 'ProjectWalletWorkPackageHandoverSteps',
              right: 'ProjectWalletWorkPackageMessageBoard',
              down: 'ProjectWalletWorkPackageLogisticSteps',
              left: false,
            };
          case 'ProjectWalletWorkPackageLogisticSteps':
            return {
              up: 'ProjectWalletWorkPackageDesignSteps',
              right: 'ProjectWalletWorkPackageMessageBoard',
              down: 'ProjectWalletWorkPackageCostSteps',
              left: false,
            };
          case 'ProjectWalletWorkPackageCostSteps':
            return {
              up: 'ProjectWalletWorkPackageLogisticSteps',
              right: 'ProjectWalletWorkPackageMessageBoard',
              down: false,
              left: false,
            };
        case 'ProjectWalletWorkPackageNoSteps':
          return {
            up: 'ProjectWalletWorkPackageCostSteps',
            right: 'ProjectWalletWorkPackageMessageBoard',
            down: false,
            left: false,
          };
        case 'ProjectWalletWorkPackageLogList':
          return {
            up: false,
            right: false,
            down: 'ProjectWalletWorkPackageImages',
            left: 'ProjectWalletWorkPackageInfo',
          };
        case 'ProjectWalletWorkPackageImages':
          return {
            up: 'ProjectWalletWorkPackageLogList',
            right: false,
            down: 'ProjectWalletWorkPackageMessageBoard',
            left: 'ProjectWalletWorkPackageWorkSteps',
          };
        case 'ProjectWalletWorkPackageMessageBoard':
          return {
            up: 'ProjectWalletWorkPackageImages',
            right: false,
            down: false,
            left: 'ProjectWalletWorkPackageQualitySteps',
          };
        case 'ProjectWalletWorkPackageCosts':
          return {
            up: false,
            right: 'ProjectWalletWorkPackageInfo',
            down: false,
            left: false,
          };
      }
    },
    microlevel_takt_days() {
      let days = [];
      let dates = this.getCalendar(this.project_id).takt_times[this.$route.params.takt_index].dates;
      dates.forEach(date => {
        let day_string = this.$store.state.Ultra.week_days[date.getDay()];
        const month_number = date.getMonth() + 1;
        days.push(`${day_string} ${date.getDate() < 10?0:''}${date.getDate()}.${month_number < 10?0:''}${month_number}.`)
      });
      return days;
    },
    microlevel_time_slots() {
      let time_slots = [];
      let project = this.$store.state.Ultra.projects[this.project_id];
      let working_time_start = project.working_time_start; //start in ms
      let working_time_duration = project.working_time_duration; //duration in ms
      if (!this.isShowMicroGrid) {
        // 15 min grid invisible, 1 hour grid visible

        // calc first full hour
        let first_full_quarter_hour = Math.ceil(working_time_start / 900);
        let first_full_quarter_hour_seconds = first_full_quarter_hour * 900;
        // calc first slot
        let first_slot_start = working_time_start;
        let first_slot_duration = first_full_quarter_hour_seconds - first_slot_start;
        let first_slot_end = first_slot_start + first_slot_duration;

        // calc last full hour
        let last_full_quarter_hour = Math.floor((working_time_start+working_time_duration) / 900);
        let last_full_quarter_hour_seconds = last_full_quarter_hour * 900;
        // calc last slot
        let last_slot_end = working_time_start+working_time_duration;
        let last_slot_duration = last_slot_end - last_full_quarter_hour_seconds;
        let last_slot_start = last_slot_end - last_slot_duration;
        // calc slots between
        let seconds_between_full_quarters = last_slot_end - last_slot_duration - first_slot_start - first_slot_duration;
        let full_quarters_count = seconds_between_full_quarters / 900;

        // fill slot array
        // first incomplete slot
        if (first_slot_duration > 0) {
          let slot_start_time = new Date(first_slot_start * 1000);
          time_slots.push({
            start: first_slot_start,
            start_time: slot_start_time,
            start_time_string: slot_start_time.toISOString().substring(11,16),
            duration: first_slot_duration,
            show_start_time: false,
            show_end_time: false,
            is_valid_slot: true,
          })
        }
        // full slots 15min
        for (let i = 0; i < full_quarters_count; i++) {
          let slot_start = first_slot_end + i * 900;
          let slot_start_time = new Date(slot_start*1000);
          let is_full_hour = false;
          if (slot_start % 3600 === 0) {
            is_full_hour = true;
          }
          time_slots.push({
            start: slot_start,
            start_time: slot_start_time,
            start_time_string: slot_start_time.toISOString().substring(11,16),
            duration: 900,
            show_start_time: is_full_hour,
            show_end_time: false,
            is_valid_slot: true,
          })
        }
        // last incomplete slot
        if (last_slot_duration > 0) {
          let slot_start_time = new Date(last_slot_start * 1000);
          time_slots.push({
            start: last_slot_start, 
            start_time: slot_start_time,
            start_time_string: slot_start_time.toISOString().substring(11,16),
            duration: last_slot_duration,
            show_start_time: false,
            show_end_time: false,
            is_valid_slot: true,
          })
        }

        return time_slots;
      } else {
        // map sections and sort by start
        let gridsections = this.getUObjects({type: 'gridsections', ids: project.gridsections}).sort((a, b) => parseFloat(a.start) - parseFloat(b.start));
        if (gridsections.length !== 0) {
          // first slot
          if (working_time_start < gridsections[0].start) {
            let first_slot_start = working_time_start;
            let first_slot_duration = gridsections[0].start - first_slot_start;
            let slot_start_time = new Date(first_slot_start * 1000);
            time_slots.push({
              start: first_slot_start,
              start_time: slot_start_time,
              start_time_string: slot_start_time.toISOString().substring(11,16),
              duration: first_slot_duration,
              show_start_time: false,
              show_end_time: false,
              is_grid: false,
            });
          }
          gridsections.forEach((gridsection, grid_index) => {
            // placeholder between grids
            if (grid_index > 0) {
              let placeholder_duration = gridsection.start - gridsections[grid_index-1].start - gridsections[grid_index-1].duration;
              if (placeholder_duration > 0) {
                let placeholder_start = gridsection.start - placeholder_duration;
                let placeholder_start_time = new Date(placeholder_start * 1000);
                time_slots.push({
                  start: placeholder_start,
                  start_time: placeholder_start_time,
                  start_time_string: placeholder_start_time.toISOString().substring(11,16),
                  duration: placeholder_duration,
                  show_start_time: true,
                  show_end_time: false,
                  is_grid: false,
                });
              }
            }
            // grid slots
            let slot_start = gridsection.start;
            let slot_duration = gridsection.duration;
            let slot_start_time = new Date(slot_start * 1000);
            time_slots.push({
              start: slot_start,
              start_time: slot_start_time,
              start_time_string: slot_start_time.toISOString().substring(11,16),
              duration: slot_duration,
              show_start_time: true,
              show_end_time: false,
              is_grid: true,
              is_valid_slot: true,
            });
          });
          // last slot
          let last_grid_end = gridsections[gridsections.length-1].start + gridsections[gridsections.length-1].duration;
          let working_time_end = working_time_start + working_time_duration;
          if (working_time_end > last_grid_end) {
            let last_slot_start = last_grid_end;
            let last_slot_duration = working_time_end - last_grid_end;
            let slot_start_time = new Date(last_slot_start * 1000);
            time_slots.push({
              start: last_slot_start,
              start_time: slot_start_time,
              start_time_string: slot_start_time.toISOString().substring(11,16),
              duration: last_slot_duration,
              show_start_time: true,
              show_end_time: false,
              is_grid: false,
            });
          }
          
        }
        return time_slots;
      }
    },
    working_time_duration() {
      return this.$store.state.Ultra.projects[this.project_id].working_time_duration;   
    },
    working_time_start() {
      return this.$store.state.Ultra.projects[this.project_id].working_time_start;   
    },
    microlevel_substeps() {
      let substeps = {};
      for (let i = 0; i < this.microlevel_takt_days.length; i++) {
        substeps[i] = {
          steps: [],
          max_x_index: 1,
        };
      }
      // let workpackages = this.getWorkpackagesInTakt({project_id: this.project_id, takt_index: this.$route.params.takt_index, trains: [], colors: [], status: [], icons: []});
      let step_cards = this.$store.state.Ultra.projects[this.project_id].step_cards[this.$route.params.takt_index]
      Object.keys(step_cards).forEach(step_card_type => {
        step_cards[step_card_type].forEach(step_card => {
          this.$store.state.Ultra['t' + step_card_type.slice(0, step_card_type.indexOf("_")) + 'steps'][step_card.id].substeps.forEach(substep_id => {
            let substep = JSON.parse(JSON.stringify(this.$store.state.Ultra.substeps[substep_id]))
            substep.workpackage_id = step_card.work_package_id;
            substep.color = step_card.work_package_color;
            substep.token = step_card.work_package_token;
            substep.icon = step_card.work_package_icon;
            substep.textcolor = step_card.work_package_textcolor;
            substep.workpackage_name = step_card.work_package_name;
            substep.taktarea_name = step_card.taktarea_name;
            substep.taktarea_id = step_card.taktarea_id;
            substep.step_type_short = step_card_type.slice(0, step_card_type.indexOf("_"))
            substep.step_id = step_card.id;
            substep.step_icon = this.$store.state.Ultra.step_icons[substep.step_type_short];
            substep.step_text = step_card.text;
            substep.start_time_string = new Date(substep.start * 1000).toISOString().substring(11,16);
            substep.end_time_string = new Date((substep.start + substep.duration) * 1000).toISOString().substring(11,16);
            substeps[substep.day_index].steps.push(substep);
          })
        })
      })
      // sort substeps an handle overlapping
      let sort_fn = function(a,b) {
        if (a.start > b.start) {
          return 1;
        }
        if (a.start < b.start) {
          return -1;
        }
        // if start is equal sort by length
        if (a.duration > b.duration) {
          return -1;
        }
        if (a.duration < b.duration) {
          return 1;
        }
        return 0;
      };
      for (let day_index = 0; day_index < this.microlevel_takt_days.length; day_index++) {
        // sort
        substeps[day_index].steps.sort(sort_fn);
        //handle overlapping;
        let used_starts = {};
        let used_x_index_in_start = {};
        substeps[day_index].steps.forEach(substep => {
          for (var i = substep.start; i < substep.start+substep.duration; i++) {
            if (used_starts[i]) {
              used_starts[i].push(substep.id);
              //handle x_index
              if (i === substep.start) {
                for (var j = 0; j < used_starts[i].length; j++) {
                  if (!used_x_index_in_start[i].includes(j)) {
                    substep.x_index = j;
                    if (j > substeps[day_index].max_x_index) {
                      substeps[day_index].max_x_index = j;
                    }
                    break;
                  }
                }
              }
              used_x_index_in_start[i].push(substep.x_index);
              //handle width
              // if (used_starts[i].length === 2) {
              //   substeps[day_index].steps.find(substep => substep.id === used_starts[i][0]).width = 0.5;
              // }
              // set width
              if (!substep.width || substep.width > (1 / used_starts[i].length)) {
                
                substep.width = (1 / used_starts[i].length);
              }
              // handle other steps
              for (let k = 0; k < used_starts[i].length-1; k++) {
                let other_substep = substeps[day_index].steps.find(st => st.id === used_starts[i][k]);
                if (other_substep.width > (1 / used_starts[i].length)) {
                  other_substep.width = (1 / used_starts[i].length);
                }
              }
              // used_starts[i].forEach(id => {
              //   let substep = substeps[day_index].steps.find(substep => substep.id === id);
              //   if (substep.width > (1 / used_starts[i].length)) {
              //     substep.width = (1 / used_starts[i].length);
              //   }
              // });
            } else {
              if (i === substep.start) {
              substep.x_index = 0;
              substep.width = 1;
              }
              used_starts[i] = [substep.id];
              used_x_index_in_start[i] = [substep.x_index];
            }
          }
        });
      }
      return substeps;
    },
    getProjectName(){
      return this.getProject(this.project_id).name;
    },
  },
  methods: {
    slotMouseEnter(slot, day_index) {
      if (this.is_mouse_down) {
        if (slot.is_grid) {
          this.substep_cache.start = slot.start;
          let start_time = new Date(slot.start * 1000);
          let start_time_string = start_time.toISOString().substring(11,16);
          this.substep_cache.start_time_string = start_time_string;
          this.substep_cache.duration = slot.duration;
          let end_time = new Date((this.substep_cache.start + this.substep_cache.duration) * 1000);
          let end_time_string = end_time.toISOString().substring(11,16);
          this.substep_cache.end_time_string = end_time_string;
        } else if (!this.initial_slot) {
          // first move , initialize and save initial slot for offset
          this.initial_slot = slot;
          this.initial_start_offset = slot.start - this.substep_cache.start;
          this.initial_end_offset = (slot.start + slot.duration) - (this.substep_cache.start + this.substep_cache.duration);
        } else {
          if (this.substep_move === 'bottom') {
            this.substep_cache.duration = (slot.start + slot.duration) - this.initial_end_offset - this.substep_cache.start;
          }
          if (this.substep_move === 'top') {
            this.substep_cache.duration = this.substep_cache.duration + (this.substep_cache.start - slot.start);
          }
          if (this.substep_move !== 'bottom') {
            this.substep_cache.start = slot.start - this.initial_start_offset;
          }


          // handle edge cases
          // duration
          if (this.substep_cache.duration < 900) {
            this.substep_cache.duration = 900;
          }
          // start
          if (this.substep_cache.start < this.working_time_start) {
            this.substep_cache.start = this.working_time_start;
          }
          // end
          if ((this.substep_cache.start + this.substep_cache.duration) > (this.working_time_start + this.working_time_duration)) {
            this.substep_cache.duration = (this.working_time_start + this.working_time_duration) - this.substep_cache.start;
          }
          // update time strings
          // start
          let start_time = new Date((this.substep_cache.start) * 1000);
          let start_time_string = start_time.toISOString().substring(11,16);
          this.substep_cache.start_time_string = start_time_string;
          // end
          let end_time = new Date((this.substep_cache.start + this.substep_cache.duration) * 1000);
          let end_time_string = end_time.toISOString().substring(11,16);
          this.substep_cache.end_time_string = end_time_string;
          
        }
        this.substep_cache.show = true;
        this.substep_cache.day_index = day_index;
      }
    },
    subStepMouseDown(substep, move) {
      this.is_mouse_down = true;
      this.is_mouse_moved = false;
      this.substep_cache = JSON.parse(JSON.stringify(substep));
      this.substep_cache.x_index = 0;
      this.substep_cache.width = 1;
      this.substep_move = move;
    },
    subStepMouseMove() {
      this.initial_slot = false;
      this.is_mouse_moved = true;
      this.show_interaction_slots = true;
    },
    clickSubStep(substep) {
      if (!this.is_mouse_moved) {
        let self = this;
        this.show_interaction_slots = true;
        this.dbl_click = false;
        setTimeout(function () {
          self.show_interaction_slots = false;
          if (!self.dbl_click) {
            self.selected_substep = substep;
            const step_type = substep.step_type_short;
            console.log('LETS GO DENNIS', substep)
            self.$router.push({
              name: `ProjectWallet${step_type.substring(0,1).toUpperCase()}${step_type.substring(1)}Cards`,
              params: {
                // project_id: project_id,
                // train_id: step_card.train_id,
                // taktarea_id: step_card.taktarea_id,
                // twaggon_id: step_card.twaggon_id,
                tworkpackage_id: substep.workpackage_id,
                takt_index: self.$route.params.takt_index,
                [`${step_type}_card_id`]: substep.step_id,
                selected_column: 'center',
              }
          })
          }
          self.dbl_click = true;
        }, 200);
      }
    },
    createSubStep(slot, day_index) {
      this.dbl_click = true;
      let new_substep = {
        start: slot.start,
        duration: slot.is_grid?slot.duration:3600,
        day_index: day_index,
      }
      // if step is open
      if (this.$route.name.includes('Cards')) {
        let step_type = this.$route.name.substring(13, this.$route.name.length - 5).toLowerCase();
        let takt_index = this.$route.params.takt_index;
        let step_id = this.$route.params[`${step_type}_card_id`];
        let step_card = this.$store.state.Ultra.projects[this.project_id].step_cards[takt_index][`${step_type}_cards`].find(card => card.id === step_id);
        let train_id = step_card.train_id;
        let taktarea_id = step_card.taktarea_id;
        let twaggon_id = step_card.twaggon_id;
        let tworkpackage_id = step_card.work_package_id;
        // create substep
        this.requestSnackbarCreate({
          url: [
            { projects: this.project_id },
            { trains: train_id },
            { taktareas: taktarea_id },
            { twaggons: twaggon_id },
            { tworkpackages: tworkpackage_id },
            { [`t${step_type}steps`]: step_id },
            { substeps: ''},
            {showWithEntitiesNormalized: ''},
          ],
          u_object: new_substep
        }).then((payload) => {
          this.createUObject(payload)
        })
        
      } else {
        // create placeholder
        new_substep.id = "create";
        new_substep.width = 1;
        new_substep.show = true;
        new_substep.x_index = 0;
        new_substep.color = 'blue';
        new_substep.text_color = 'white';
        new_substep.icon = 'add-circle';
        new_substep.token = 'NEW SUBSTEP';
        new_substep.step_text = 'Select Step from List'

        // start
        let start_time = new Date((new_substep.start) * 1000);
        let start_time_string = start_time.toISOString().substring(11,16);
        new_substep.start_time_string = start_time_string;
        // end
        let end_time = new Date((new_substep.start + new_substep.duration) * 1000);
        let end_time_string = end_time.toISOString().substring(11,16);
        new_substep.end_time_string = end_time_string;


        this.substep_cache = new_substep;
        this.setValue({key: 'new_substep_step_id', value: -1})
        this.setValue({key: 'new_substep_step_type', value: false}),
        this.setValue({key: 'new_substep_search_step_id', value: true})
      }
    },
    ...mapActions('ProjectWallet', [
      'updateStepCardStatus',
      'setWalletSettings',
      'increaseUpdateKeyStepCard',
      'resetWalletSettings',
      'resetWalletStepFilter'
    ]),
    ...mapActions('Ultra', [
      'requestUObject',
      'createUObject',
      'updateUObject',
      'deleteUObject',
    ]),
    ...mapActions('ProjectCalendar', [
      'setShowCalendarWeeks',
    ]),
    ...mapActions('TWorkPackage', [
      'requestTWorkPackage',
      'addStepImage'
    ]),
    ...mapActions('WorkPackageLogList', [
      'createLogListComment'
    ]),
    ...mapActions('View', [
      'setMobileWalletShowSettings',
      'setWalletWorkpackageHeaderItems',
      'setWalletShowWorkpackages',
      'setValue',
    ]),
    ...mapActions('SnackBar', [
      // 'requestSnackbar',
      'requestSnackbarCreate',
      'requestSnackbarUpdate',
      // 'requestSnackbarUpdateParent',
      // 'requestSnackbarDelete',
      'updateSnackbar',
      'applySnackbar',
      // 'applySnackbarCreateElements',
      // 'applySnackbarUpdateElements',
    ]),
    getSectionArray() {
      let sorting = this.getWalletSettings.sorting;
      // if(this.isMicroView){
      //   let array = JSON.parse(JSON.stringify(this.getProjectTaktareas(this.project_id)))
      //   console.log('dsfdfgdsg', array);
      //   return array ;
      // }
      // Trains
      if (sorting === 'trains') {
        let array = JSON.parse(JSON.stringify(this.getProject(this.project_id).trains));
        let trains = this.getWalletSettings.trains;
        let index = array.indexOf(trains[0]);
        if (index > 0) {
          let insert = array.splice(index, 1);
          array.splice(0, 0, insert);
        }
        return array;
      }
      // taktareas
      if (sorting === 'taktareas') {
        let array = JSON.parse(JSON.stringify(this.getProjectTaktareas(this.project_id)));
        let taktareas = this.getWalletSettings.taktareas;
        let index = array.indexOf(taktareas[0]);
        if (index > 0) {
          let insert = array.splice(index, 1);
          array.splice(0, 0, insert);
        }
        return array;
      }
      // Colors
      else if (sorting === 'colors') {
        let array = JSON.parse(JSON.stringify(this.getTWorkpackageColors));
        let colors = this.getWalletSettings.colors;
        let index = array.findIndex(entry => entry.value === colors[0]);
        if (index > 0) {
          let insert = array.splice(index, 1);
          array.splice(0, 0, insert[0]);
        }
        return array;
      }
      //Status
      else if (sorting === 'status') {
        let array = JSON.parse(JSON.stringify(this.getFullStatusArray)).slice(0, -1);
        let status = this.getWalletSettings.status;
        let index = array.findIndex(entry => entry.value === status[0]);
        if (index > 0) {
          let insert = array.splice(index, 1);
          array.splice(0, 0, insert[0]);
        }
        array.splice(0, 0, {name: 'stop', value: 'stop', color: 'grey darken-4', icon: 'exclamation-triangle-negative', tooltip: 'Stop'});
        return array;
      }
      // Icons
      else if (sorting === 'icons') {
        let array = JSON.parse(JSON.stringify(this.getTWorkpackageIcons));
        let icons = this.getWalletSettings.icons;
        let index = array.findIndex(entry => entry.value === icons[0]);
        if (index > 0) {
          let insert = array.splice(index, 1);
          array.splice(0, 0, insert[0]);
        }
        return array;
      }
      else {
        return this.getProject(this.project_id).trains;
      }
    },
    getWorkpackagesInTaktComputed: function(takt_index, sorting, section) {
      let payload = {
        project_id: this.project_id,
        takt_index: takt_index,
        trains: [],
        colors: [],
        status: [],
        icons: [],
      };
      if (sorting === 'trains') {
        payload.trains.push(section);
      } else if (sorting === 'colors') {
        payload.colors.push(section.value);
      } else if (sorting === 'status') {
        payload.status.push(section.value);
      } else if (sorting === 'icons') {
        payload.icons.push(section.value);
      }
      return this.getWorkpackagesInTakt(payload);
    },
    selectWorkpackageImage(image) {
      let image_name = image.name;
      let arr = image_name.split(".");
      let ext = arr[arr.length-1];

      let type = getFileTypeFromExtenion(ext);

      this.new_image.extension = ext;
      this.new_image.type = type;

      this.new_image.file = image;
      this.new_image.local_url = URL.createObjectURL(image);
      this.new_image.name = image.name;
      this.update_key_add_image++;
    },
    uploadWorkpackageImage(train_id, taktarea_id, twaggon_id, tworkpackage_id) {
      if (this.new_image.file) {
      let image = new FormData();
      image.append("image", this.new_image.file);
      this.createUObject({
        url: [
          {projects: this.project_id},
          {trains: train_id},
          {taktareas: taktarea_id},
          {twaggons: twaggon_id},
          {tworkpackages: tworkpackage_id},
          {tworkpackageimages: ''},
          {showWithEntitiesNormalized: ''}
        ],
        image: image
      }).then(id => {
        this.updateUObject({
          url: [
            {projects: this.project_id},
            {trains: train_id},
            {taktareas: taktarea_id},
            {twaggons: twaggon_id},
            {tworkpackages: tworkpackage_id},
            {tworkpackageimages: id}
          ],
          update: {
            comment: this.new_image.comment
          }
        }).then(() => {
          this.new_image = {
            file: false,
            local_url: false,
            name: false,
            comment: '',
            extension: '',
            type: 'other'
          };
          this.update_key_add_image++;
          this.scrollBottomImages('images');
        });
      });
    }
  },
  selectStepImage(image){
    let arr = image.name.split(".");
    let ext = arr[arr.length-1];
    let file_type = getFileTypeFromExtenion(ext);

    this.new_step_image = {
      file: image,
      local_url: URL.createObjectURL(image),
      name: image.name,
      comment: '',
      step_id: this.step.id,
      type: file_type,
      extension: ext,
      step_type: this.step_type
    };
    this.update_key_add_image++;
  },
  uploadStepImage() {
    if (this.new_step_image.file) {
    let image = new FormData();
    image.append("image", this.new_step_image.file);

    this.createUObject({
      url: [
        {projects: this.project_id},
        {trains: this.step_card.train_id},
        {taktareas: this.step_card.taktarea_id},
        {twaggons: this.step_card.twaggon_id},
        {tworkpackages: this.step_card.work_package_id},
        {[`t${this.step_type}steps`]: this.step.id},
        {tworkpackageimages: ''},
        {showWithEntitiesNormalized: ''},
      ],
      image: image
    }).then(id => {
      this.addStepImage({
        tworkpackage_id: this.step_card.work_package_id,
        image_id: id
      });
      this.updateUObject({
        url: [
          {projects: this.project_id},
          {trains: this.step_card.train_id},
          {taktareas: this.step_card.taktarea_id},
          {twaggons: this.step_card.twaggon_id},
          {tworkpackages: this.step_card.work_package_id},
          {tworkpackageimages: id}
        ],
        update: {
          comment: this.new_step_image.comment
        }
      }).then(() => {
        this.new_step_image = {
          file: false,
          local_url: false,
          name: false,
          comment: '',
          step_id: false,
          extension: '',
          type: 'other'
        };
        this.update_key_add_image++;
      });
    });
  }
},
  walletSwipeStart(evt) {
    this.first_touch = evt;
  },
  walletSwipeEnd(evt) {
    var differenceX = this.first_touch.touches[0].clientX -  evt.changedTouches[0].clientX;
    var differenceY = this.first_touch.touches[0].clientY -  evt.changedTouches[0].clientY;
    var timeDifference = evt.timeStamp - this.first_touch.timeStamp;
    //right
    if (differenceX > 100 && Math.abs(differenceY) < 100 && timeDifference < 200) {
      let direction = 'right';
      if (this.$route.name === 'ProjectWalletTakt') {
        this.$router.push({
          name: 'ProjectWalletTakt',
          params: {
            takt_index: parseInt(this.$route.params.takt_index) + parseInt(1),
            direction: direction,
          }
        });
      }
      // workpackage navigation
      // else if (this.getWaggonInfoNavigation[direction]) {
      //   this.nav_direction = direction,
      //   this.$router.push({
      //     name: this.getWaggonInfoNavigation[direction],
      //     params: {direction: direction},
      //   });
      // }
    }
    //left
    else if (differenceX < -100 && Math.abs(differenceY) < 100 && timeDifference < 200) {
      let direction = 'left';
      if (this.$route.name === 'ProjectWalletTakt') {
        this.$router.push({
          name: 'ProjectWalletTakt',
          params: {
            takt_index: parseInt(this.$route.params.takt_index) - parseInt(1),
            direction: direction,
          }
        });
      }
      // workpackage navtigation
      // else if (this.getWaggonInfoNavigation[direction]) {
      //   this.nav_direction = direction,
      //   this.$router.push({
      //     name: this.getWaggonInfoNavigation[direction],
      //     params: {direction: direction},
      //   });
      // }
    }
    //down
    // else if (differenceY > 100 && Math.abs(differenceX) < 100 && timeDifference < 200) {
    //   if (this.$route.name !== 'ProjectWalletTakt') {
    //       let direction = 'down';
    //       this.nav_direction = direction,
    //       this.$router.push({
    //         name: this.getWaggonInfoNavigation[direction],
    //         params: {direction: direction},
    //       });
    //   }
    // }
    //up
    // else if (differenceY < -100 && Math.abs(differenceX) < 100 && timeDifference < 200) {
    //   if (this.$route.name !== 'ProjectWalletTakt') {
    //     let direction = 'up';
    //     this.nav_direction = direction,
    //     this.$router.push({
    //       name: this.getWaggonInfoNavigation[direction],
    //       params: {direction: direction},
    //     });
    //   }
    // }
    this.first_touch = {};
  },
  walletWorkpackageClick(twork_package) {
    if (this.$route.params.nav_back) {
      this.$router.push({
        name: this.$route.params.nav_back
      });
    } else {
      if (this.wallet_column === this.selected_column) {
        this.$router.push({
          name: 'ProjectWalletTakt'
        });
      }
      // else if (this.$vuetify.breakpoint.smAndDown &&
      //             this.selected_twork_package_id !== twork_package.id) {
      //   this.selected_twork_package_id = twork_package.id;
      // }
    //   else {
    //     this.$router.push({
    //     name: 'ProjectWalletWorkPackageInfo',
    //     params: {
    //       project_id: this.project_id,
    //       train_id: twork_package.train.id,
    //       taktarea_id: twork_package.taktarea.id,
    //       twaggon_id: twork_package.twaggon.id,
    //       tworkpackage_id: twork_package.id,
    //       selected_column: this.wallet_column,
    //     }
    //   });
    // }
    // else if (this.$vuetify.breakpoint.smAndDown &&
    //             this.selected_twork_package_id !== twork_package.id) {
    //   this.selected_twork_package_id = twork_package.id;
    // }
    else {
      let on_site = this.getUseOnSite;
      this.$router.push({
      name: on_site ? 'ProjectWalletWorkPackageWorkSteps' :'ProjectWalletWorkPackageInfo',
      params: {
        project_id: this.project_id,
        train_id: twork_package.train.id,
        taktarea_id: twork_package.taktarea.id,
        twaggon_id: twork_package.twaggon.id,
        tworkpackage_id: twork_package.id,
        selected_column: this.wallet_column,
      }
    });
  }
  }
},
test() {
  // console.log(this.getCalendar(this.project_id));
}
}
}
